// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import store from './store/index.js'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import { langData } from '@/lib/lang/index.js'
import { isEmpty } from 'lodash'
import axios from 'axios'
import VueCryptojs from 'vue-cryptojs'
import VueGtag from 'vue-gtag'

// Vuex
Vue.use(Vuex)
// vue-crypto
Vue.use(VueCryptojs)

// Gtag
if (!isEmpty(process.env.GA_MEASUREMENT_ID)) {
  Vue.use(VueGtag, {
    config: { id: process.env.GA_MEASUREMENT_ID }
  })
}

// i18n多言語設定
Vue.use(VueI18n)
// SessionStorageで保持している設定を取得
var lang = sessionStorage.getItem('lang')
switch (lang) {
  case 'ja':
  case 'en':
    // 正しく言語設定されている場合は何もしない
    break
  default:
    // nullやundefindeの場合（画面の初期表示時）、またja/en以外に改ざんされた場合は初期値として常にjaを設定
    lang = 'ja'
    sessionStorage.setItem('lang', lang)
}
const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: 'ja',
  messages: langData
})

Vue.config.productionTip = false
Vue.prototype.axios = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  i18n,
  store,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js